import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import QuestionFields from './QuestionFields'

const defaultValue = {
    type: 'RADIO'
}
export const QuestionCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list" defaultValue={defaultValue}>
            <Grid container spacing={8}>
                <QuestionFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default QuestionCreate
